TYPE_CONTINUE_WATCHING_ONLY